import React from 'react';

const Japanese = () => {
    return (
        <div className='mt-5 pt-5'>
            <h1>Hello, Japanese Website coming soon after completing N1 level </h1>
        </div>
    );
};

export default Japanese;